<div class="add-farmhouse-main" [formGroup]="farmHouseFormGroup">
    <div class="farmhouse-form-grid">
        <div class="input-group-farm">
            <label for="name{{ index }}"
                >Farmhouse Name:<span class="text-danger-required"
                    >*</span
                ></label
            >
            <input
                id="name{{ index }}"
                formControlName="name"
                class="form-control"
                placeholder="Enter farmhouse name"
                [ngClass]="{
                    'is-invalid': isControlInvalid('name'),
                    'is-valid':
                        !isControlInvalid('name') &&
                        farmHouseFormGroup.get('name').touched
                }"
            />
            <div
                class="invalid-feedback"
                *ngIf="
                    farmHouseFormGroup.get('name').invalid &&
                    farmHouseFormGroup.get('name').touched
                "
            >
                <span *ngIf="farmHouseFormGroup.get('name').errors?.required"
                    >Farmhouse name is required.</span
                >
                <span
                    *ngIf="farmHouseFormGroup.get('name').errors?.reservedName"
                    >Cannot use reserved house names: '0' or 'House 0'.</span
                >
            </div>
        </div>

        <div class="input-group-farm">
            <label for="length{{ index }}"
                >Length (m):<span class="text-danger-required">*</span></label
            >
            <input
                id="length{{ index }}"
                formControlName="length"
                type="number"
                min="0"
                step="0.01"
                class="form-control"
                placeholder="0.00"
                [ngClass]="{
                    'is-invalid': isControlInvalid('length'),
                    'is-valid':
                        !isControlInvalid('length') &&
                        farmHouseFormGroup.get('length').touched
                }"
            />
            <div
                class="invalid-feedback"
                *ngIf="
                    farmHouseFormGroup.get('length').invalid &&
                    (farmHouseFormGroup.get('length').touched ||
                        farmHouseFormGroup.get('length').dirty)
                "
            >
                <span
                    *ngIf="
                        farmHouseFormGroup.get('length').errors?.['required']
                    "
                    >Length is required.</span
                >
                <span *ngIf="farmHouseFormGroup.get('length').errors?.min"
                    >Length must be greater than 0.</span
                >
            </div>
        </div>

        <div class="input-group-farm">
            <label for="width{{ index }}"
                >Width (m):<span class="text-danger-required">*</span></label
            >
            <input
                id="width{{ index }}"
                formControlName="width"
                type="number"
                min="0"
                step="0.01"
                class="form-control"
                placeholder="0.00"
                [ngClass]="{
                    'is-invalid': isControlInvalid('width'),
                    'is-valid':
                        !isControlInvalid('width') &&
                        farmHouseFormGroup.get('width').touched
                }"
            />
            <div
                class="invalid-feedback"
                *ngIf="
                    farmHouseFormGroup.get('width').invalid &&
                    (farmHouseFormGroup.get('width').touched ||
                        farmHouseFormGroup.get('width').dirty)
                "
            >
                <span *ngIf="farmHouseFormGroup.get('width').errors?.required"
                    >Width is required.</span
                >
                <span *ngIf="farmHouseFormGroup.get('width').errors?.min"
                    >Width must be greater than 0.</span
                >
            </div>
        </div>
         <div class="input-group-farm">
            <label for="feedingSiloCapacity{{ index }}"
                >Feeding Silo Capacity:<span class="text-danger-required">*</span></label
            >
            <input
                id="feedingSiloCapacity{{ index }}"
                formControlName="feedingSiloCapacity"
                type="number"
                min="0"
                step="0.01"
                class="form-control"
                placeholder="0.00"
                [ngClass]="{
                    'is-invalid': isControlInvalid('feedingSiloCapacity'),
                    'is-valid':
                        !isControlInvalid('feedingSiloCapacity') &&
                        farmHouseFormGroup.get('feedingSiloCapacity').touched
                }"
            />
            <div
                class="invalid-feedback"
                *ngIf="
                    farmHouseFormGroup.get('feedingSiloCapacity').invalid &&
                    (farmHouseFormGroup.get('feedingSiloCapacity').touched ||
                        farmHouseFormGroup.get('feedingSiloCapacity').dirty)
                "
            >
                <span *ngIf="farmHouseFormGroup.get('feedingSiloCapacity').errors?.required"
                    >Feeding Silo Capacity is required.</span
                >
                <span *ngIf="farmHouseFormGroup.get('feedingSiloCapacity').errors?.min"
                    >Feeding Silo Capacity must be greater than 0.</span
                >
            </div>
        </div>
        <div class="input-group-farm">
            <label for="feedingSiloHeight{{ index }}"
                >Feeding Silo Height:<span class="text-danger-required">*</span></label
            >
            <input
                id="feedingSiloHeight{{ index }}"
                formControlName="feedingSiloHeight"
                type="number"
                min="0"
                step="0.01"
                class="form-control"
                placeholder="0.00"
                [ngClass]="{
                    'is-invalid': isControlInvalid('feedingSiloHeight'),
                    'is-valid':
                        !isControlInvalid('feedingSiloHeight') &&
                        farmHouseFormGroup.get('feedingSiloHeight').touched
                }"
            />
            <div
                class="invalid-feedback"
                *ngIf="
                    farmHouseFormGroup.get('feedingSiloHeight').invalid &&
                    (farmHouseFormGroup.get('feedingSiloHeight').touched ||
                        farmHouseFormGroup.get('feedingSiloHeight').dirty)
                "
            >
                <span *ngIf="farmHouseFormGroup.get('feedingSiloHeight').errors?.required"
                    >Feeding Silo Height is required.</span
                >
                <span *ngIf="farmHouseFormGroup.get('feedingSiloHeight').errors?.min"
                    >Feeding Silo Height must be greater than 0.</span
                >
            </div>
        </div>
    </div>

    <div class="partition-container">
        <div formArrayName="farmHousePartitions" class="farmhouse-partition">
            <div
                class="partition-group"
                *ngFor="
                    let partitionGroup of farmHousePartitions.controls;
                    let k = index
                "
                [formGroupName]="k"
            >
                <div class="accordion">
                    <div class="partition-header-row">
                        <div class="accordion-header" (click)="setOpenFarm(k)">
                            <h4>Partition {{ k + 1 }}</h4>
                            <i
                                class="fas fa-chevron-down"
                                [ngClass]="{rotate: openFarmIndex === k}"
                            ></i>
                        </div>
                        <button
                            class="btn btn-remove-partition"
                            type="button"
                            (click)="removeFarmHousePartition(k)"
                            title="Remove this partition"
                        >
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </div>
                    <div
                        class="accordion-body"
                        [ngClass]="{show: openFarmIndex === k}"
                    >
                        <app-add-farmhouse-partition
                            [partitionFormGroup]="partitionGroup"
                            [index]="k"
                            (removeFarmHousePartitionEvent)="
                                removeFarmHousePartition($event)
                            "
                        >
                        </app-add-farmhouse-partition>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="action-buttons">
        <button
            class="btn add-partition"
            type="button"
            (click)="addFarmHousePartition()"
            title="Add a new partition"
        >
            <i class="fas fa-plus"></i> Add Partition
        </button>
    </div>
</div>
